export enum StatusLayerIds {
  MAIN_STREET_GREEN_LAYER_ID = 'MAIN_STREET_GREEN',
  COMMUNICATION_STATUS_LAYER_ID = 'COMMUNICATION_STATUS',
  ICONS_LAYER_ID = 'INTERSECTION_ICONS',
  TIME_SYNC_STATUS_LAYER_ID = 'TIME_SYNC',
  COORDINATION_STATUS_LAYER_ID = 'COORDINATION_STATUS',
  PREEMPT_STATUS_LAYER_ID = 'PREEMPT_STATUS',
  CROSSHAIR_STATUS_LAYER_ID = 'CROSSHAIR_STATUS',
  ALARM_STATUS_LAYER_ID = 'ALARM_STATUS',
  APPLIED_COMMANDS_STATUS_LAYER_ID = 'APPLIED_COMMANDS_STATUS',
}

export const SignalStatusLayers = [
  StatusLayerIds.MAIN_STREET_GREEN_LAYER_ID,
  StatusLayerIds.COMMUNICATION_STATUS_LAYER_ID,
  StatusLayerIds.TIME_SYNC_STATUS_LAYER_ID,
  StatusLayerIds.COORDINATION_STATUS_LAYER_ID,
  StatusLayerIds.PREEMPT_STATUS_LAYER_ID,
  StatusLayerIds.ALARM_STATUS_LAYER_ID,
  StatusLayerIds.APPLIED_COMMANDS_STATUS_LAYER_ID,
];
